<template>
  <div class="errorbody container" :class="theme_type">
    <div v-if="theme_type=='showtime'" class="container">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a class="secondary_title" href="/">Home</a>
        </li>
        <li class="breadcrumb-item secondary_title active">404 Not Found</li>
      </ol>
    </div>
    <h1>404 Page Not Found</h1>
    <v-line v-if="theme_type!='showtime'"></v-line>
    <p>
      The page you were looking for does not exist.
      <a href="/">Click here</a> to continue shopping.
    </p>
  </div>
</template>
<script>
export default {
  props: ["theme_type"],
  data() {
    return {};
  },
  mounted() {
    console.log("theme_type", this.theme_type);
  },
  methods: {}
};
</script>
<style scoped lang='scss'>
.errorbody {
  text-align: center;

  h1 {
    margin-top: 160px;
    font-size: 26px;
  }

  p {
    font-size: 15px;

    a {
      color: #a26b25;
      text-decoration: none;
    }
  }
}
.venue {
  padding-bottom: 90px !important;
}
.showtime {
  h1 {
    margin-top: 30px;
  }
  p{
    margin-bottom: 60px;
  }
}
</style>